import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
// import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import CourseFinder from '../../courseFinder'
import styles from './styles.less'
import Each from "async/each";
import {
    Button,
    Card,
    Col,
    Drawer,
    Form,
    Icon,
    Input,
    InputNumber,
    notification,
    Radio,
    Row,
    Select,
    Table,
    Tabs,
    Tooltip,
    Steps,
    Modal,
    Popover
} from 'antd'

import {
    FaWhatsappSquare,
} from "react-icons/fa";

import _ from 'lodash'
import StudentHeader from '../../../../components/studentHeader'
import moment from 'moment'
import { hideLoader, showLoader } from '../../../../modules/actions'

import { HiInformationCircle } from "react-icons/hi";
import Request, { API_URL } from '../../../../request'
import { connect } from 'react-redux'
import { getUrlPushWrapper } from '../../../../routes'
import StudentInfo from '../../../../components/StudentInfo'
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const TabPane = Tabs.TabPane
const RadioGroup = Radio.Group
const Option = Select.Option
const { Step } = Steps


const content = {
    "qualityRating": "Quality Rating",
    "conversionRating": "Conversion Rating",
    "status": "Status"
}

class CountryPreference extends PureComponent {
    state = {
        visible: true,
        country: null,
        city: null,
        countryArr: [],
        totalPreference: [],

    }

    componentDidMount() {
        this.loadCountries()
        this.loadData()
    }



    loadData = async () => {
        let { inquiryId } = this.props
        let response = await Request.getInquiry(inquiryId)
        if (response && response.doc && response.doc.totalPreference) {
            let x = [];
            Each(
                response.doc.totalPreference,
                async (item, done) => {
                    let country = await Request.getCountry(item.countryId);
                    let city = "";
                    if (item.cityId !== "") {
                        city = await Request.getCity(item.cityId);
                    }

                    let a = {};
                    a.country = country.doc;
                    a.city = city.doc;
                    x.push(a);
                    done()
                }, () => {
                    this.setState({ totalPreference: x, responseData: response.doc });
                }
            );
            // this.setState({totalPreference: x})
        }
        // this.setState({totalPreference:response.doc.totalPreference})
    }

    loadCountries = () => {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId,
        };
        Request.getCountriesWithoutAuth({ ...params })
            .then((resp) => {
                let countryFieldArr = [];
                let phoneCodes = [];
                let countryPhoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    countryFieldArr.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        countryPhoneCodes[vv._id] = vv.countryPhoneCode;
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    temp.push({ ...vv });
                    return temp;
                }, []);
                this.setState({ countryArr: resp.data, countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = async () => {
        let totalPreference
        let data = []
        _.each(this.state.totalPreference, (item) => {
            let abc = {};
            abc.country = item.country.countryName;
            abc.city =
                item.city && item.city.cityName != null ? item.city.cityName : "";
            abc.countryId = item.country._id;
            abc.cityId =
                item.city && item.city._id != null ? item.city._id : "";
            data.push(abc);
        });
        totalPreference = data;
        let dataToUpdate = {
            _id: this.props.inquiryId,
            valData: { totalPreference: totalPreference }
        }
        // let data = {
        //     _id:this.props.inquiryId,
        //     valData:{totalPreference:this.state.totalPreference}
        // }
        let response = await Request.updateInquiry(dataToUpdate)
        if (response.success) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
        this.setState({
            totalPreference: [],
            country: null,
            city: null
        })
        this.onClose()
    }


    loadCities = (countryId) => {
        return new Promise(async (resolve) => {
            let data = await Request.loadCitiesByCountry(countryId);
            this.setState({ cityArr: data.result });
        });
    };

    render() {
        let { visible } = this.state

        const colum = [
            {
                title: "Country",
                key: "country",
                dataIndex: "country",
                render: (item) => {
                    return item.countryName;
                },
            },
            {
                title: "City",
                key: "city",
                dataIndex: "city",
                render: (item) => {
                    return item && item.cityName != null ? item.cityName : "";
                },
            },
            {
                title: "Action",
                key: "operation",

                render: (val, record) => (
                    <a
                        onClick={() => {
                            let tt = this.state.totalPreference;
                            tt = _.reject(tt, val);
                            this.setState({ totalPreference: tt });
                        }}
                    >
                        Remove
                    </a>
                ),
            },
        ];
        return (
            <Drawer title={
                <div>
                    <React.Fragment>
                        Country Preference
                    </React.Fragment>
                </div>
            }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1100}
                visible={visible}>
                <Card>
                    <Row gutter={16}>
                        <div>
                            <div className={"referenceItem"}>
                                <div>
                                    <h4>Select Countries</h4>
                                    <Select
                                        placeholder="Select Country"
                                        showSearch={true}
                                        style={{ width: 200 }}
                                        optionFilterProp="children"
                                        value={
                                            this.state.country
                                                ? this.state.country._id
                                                : undefined
                                        }
                                        onChange={(ei) => {
                                            let singleCountry = _.find(
                                                this.state.countryArr,
                                                (item) => {
                                                    return item._id == ei;
                                                }
                                            );

                                            if (singleCountry) {
                                                this.loadCities(singleCountry._id);
                                            }
                                            this.setState({ country: singleCountry, city: null });
                                        }}
                                    >
                                        {this.state.countryArr.map((val, index) => {
                                            return (
                                                <Option key={index} value={val._id}>
                                                    {val.countryName}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </div>
                                <div>
                                    <h4>Select Cities</h4>

                                    <Select
                                        placeholder="Select City"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        style={{ width: 200 }}
                                        value={
                                            this.state.city ? this.state.city._id : undefined
                                        }
                                        onChange={(ei) => {
                                            let singleCity = _.find(
                                                this.state.cityArr,
                                                (item) => {
                                                    return item._id == ei;
                                                }
                                            );
                                            if (singleCity) {
                                                this.loadCities(singleCity._id);
                                            }
                                            this.setState({ city: singleCity });
                                        }}
                                    >
                                        {this.state.cityArr &&
                                            this.state.cityArr.map((val, index) => {
                                                return (
                                                    <Option key={index} value={val._id}>
                                                        {val.cityName}
                                                    </Option>
                                                );
                                            })}
                                    </Select>
                                </div>

                                <div>
                                    <Button
                                        style={{
                                            marginTop: 25,
                                            marginBottom: 23,
                                        }}
                                        size={"small"}
                                        onClick={() => {
                                            if (!this.state.country) {
                                                return notification.error({
                                                    message: "Choose Country",
                                                });
                                            }

                                            if (this.state.country) {
                                                let tt = this.state.totalPreference;
                                                tt.push({
                                                    country: this.state.country,
                                                    city: this.state.city,
                                                });
                                                this.setState(
                                                    {
                                                        totalPreference: tt,
                                                        city: null,
                                                        country: null,
                                                    },
                                                    () => { }
                                                );
                                            }
                                        }}
                                    >
                                        ADD TO PREFERENCES
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Table
                                size={"small"}
                                pagination={{
                                    defaultPageSize: 10,
                                    showSizeChanger: false,
                                    showQuickJumper: false,
                                }}
                                bordered={true}
                                columns={colum}
                                dataSource={this.state.totalPreference}
                            />
                        </Col>
                    </Row>
                    <Button onClick={() => {
                        this.handleSubmit()
                    }}>SAVE</Button>
                </Card>
            </Drawer>
        )
    }
}


@Form.create()
class AddCounselling extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            inquiryId: null,
            info: {},
            visible: false,
            prferenceDrawer: false,
            maritalStatus: null,
            reference: [],
            course: [],
            countryArr: [],
            name: null,
            mobile: null,
            country: null,
            moveNext: false,
            screenLoad: false,
            allUsers: [],
            registrationUserId: [],
            parentRatings: [],
            subRatings: [],
            rating: '',
            subRating: '',
            leadStatuses: [],
            leadStatus: null,
            maritalArr: [],
            current: 0,
            stepsStatus: null,
            suggestedCourses: [],
            showReferFriend: false,
            showReferFriendSection: null,
            dealingCountryArr: [],
            dealingCountryFieldArr: [],
            dealingPhoneCodes: [],
            dealingCountryPhoneCodes: [],
            referenceList: [],
            accompanyingDetails: null,
            admissionUserId: [],
            admissionUsers: [],
        }

        this.loadAllCountries();
        this.loadDealingCountries();
    }


    next() {
        if (this.state.current == 1) {
            if (!this.state.rating) {
                notification.error({
                    message: 'Required',
                    description: 'Choose Rating'
                })
                return
            }
            if (!this.state.subRating) {
                notification.error({
                    message: 'Required ',
                    description: 'Choose Sub Rating'
                })
                return
            }
            if (!this.state.maritalStatus) {
                notification.error({
                    message: 'Required ',
                    description: 'Choose Marital Status'
                })
                return
            }
            if (!this.state.leadStatus) {
                notification.error({
                    message: 'Required ',
                    description: 'Choose Lead Status'
                })
                return
            }
            const formValues = this.props.form.getFieldsValue();
            if (formValues && Object.keys(formValues).length > 0) {
                this.setState({ accompanyingDetails: formValues });
            }
        }
        if (this.state.current == 2) {

            if (!this.state.course.length) {
                notification.error({
                    message: 'Required',
                    description: 'Choose Courses'
                })
                return
            }
        }
        const current = this.state.current + 1;
        this.setState({ current });
    }
    updateEligibleReason() {
        this.setState({ showNotEligibleDrawer: true })
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    getAllowedQualityOptions = () => {
        const current = this.state.qualityRating;
        const qualityLevels = ["Qualified", "Potential", "Unqualified"];

        // If nothing selected, show all in correct order
        if (!current) return qualityLevels;

        const currentIndex = qualityLevels.indexOf(current);

        // Allow SAME or LOWER index = upgrade only
        return qualityLevels.slice(0, currentIndex + 1);
    };



    // handleQualityRatingChange = (newValue) => {
    //     const order = {
    //         "Unqualified": 1,
    //         "Potential": 2,
    //         "Qualified": 3
    //     };

    //     const oldValue = this.state.qualityRating;

    //     // Allow on first selection
    //     if (!oldValue) {
    //         this.setState({ qualityRating: newValue });
    //         return;
    //     }

    //     // Prevent downgrade
    //     if (order[newValue] < order[oldValue]) {
    //         notification.error(`You cannot downgrade from ${oldValue} to ${newValue}`);
    //         return;
    //     }

    //     // Allowed → update
    //     this.setState({ qualityRating: newValue });
    // };


    handleSubmit = e => {
        const { dispatch, form } = this.props
        let { course } = this.state
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let followUpdata = {
                    date: valData && valData.date,
                    detail: valData && valData.detail,
                    _id: this.state.inquiryId,
                    followUpType: valData && valData.followUpType
                }
                values.withSMS = 'With SMS'
                if (!this.state.rating) {
                    notification.error({
                        message: 'Required',
                        description: 'Choose Rating'
                    })
                    return
                }
                if (!this.state.subRating) {
                    notification.error({
                        message: 'Required ',
                        description: 'Choose Sub Rating'
                    })
                    return
                }
                if (!this.state.maritalStatus) {
                    notification.error({
                        message: 'Required ',
                        description: 'Choose Marital Status'
                    })
                    return
                }
                if (!this.state.leadStatus) {
                    notification.error({
                        message: 'Required ',
                        description: 'Choose Lead Status'
                    })
                    return
                }


                if (this.state.studentAtLevel != "Front Desk" && course && course.length < 1) {
                    notification.error({
                        message: 'Required',
                        description: 'Required Course'
                    })
                    return
                }

                if (this.state.showReferFriendSection === null) {
                    notification.error({
                        message: 'Required',
                        description: 'Choose Refer a Friend Option'
                    })
                    return
                }


                let findUnSelectedCourseList = course.filter(c => c.mainCampus && c.mainCampus.length > 0 && c.campusId == null)
                if (findUnSelectedCourseList.length > 0) {
                    notification.error({
                        message: 'Required',
                        description: 'Campus is required'
                    })
                    return
                }

                let obj = {
                    _id: this.state.inquiryId,
                    leadStatus: this.state.leadStatus,
                    counsellingDesk: {
                        ...values,
                        ...this.state.accompanyingDetails,
                        maritalStatus: this.state.maritalStatus,
                        course: this.state.course,
                        completed: true,
                        rating: this.state.rating,
                        qualityRating: this.state.qualityRating,
                        subRating: this.state.subRating
                    }
                }

                if (this.state.showReferFriendSection && this.state.referenceList.length) {
                    obj.references = this.state.referenceList;
                }
                dispatch(showLoader())


                if (followUpdata.date && !followUpdata.detail) {
                    dispatch(hideLoader())

                    return notification.error({
                        message: 'Required',
                        description: 'Required followUp detail'
                    })
                } else if (!followUpdata.date && followUpdata.detail) {
                    dispatch(hideLoader())

                    return notification.error({
                        message: 'Required',
                        description: 'Required followUp date'
                    })
                }
                let x = await Request.addCounselling({ ...obj })
                let y = await Request.addCounsellingfollowUp(followUpdata)

                dispatch(hideLoader())

                if (x) {
                    if (!x.error) {
                        this.props.form.setFieldsValue({
                            date: '',
                            detail: '',
                            followUpType: ''
                        })

                        if (x.doc.counsellingDesk) {
                            let { admissionUsers } = x;
                            let { counsellingDesk, atLevel } = x.doc
                            if (counsellingDesk.completed == true && atLevel == 'Front Desk') {
                                this.setState({ moveNext: true, admissionUsers })
                            }
                        }

                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }
    setFormValues = async inquiryId => {
        const { form } = this.props
        try {

            this.setState({ screenLoad: true })

            let { doc, admissionUsers } = await Request.getInquiry(inquiryId);
            if (doc) {
                if (doc.profile && doc.profile.newQualification && doc.profile.newQualification.length && doc.totalPreference && doc.totalPreference.length) {
                    this.loadSuggestedCourses();
                }

                let docLoaded = doc.counsellingDesk || {}
                this.setState({ studentAtLevel: doc.atLevel, maritalStatus: doc.maritalStatus }, () => {
                    form.setFieldsValue(docLoaded)
                });
                let followUpDataDisplay = doc.followUp
                if (doc.references && doc.references.length) {
                    this.setState({ referenceList: doc.references, showReferFriendSection: true })
                }

                let followupRequired = _.isEmpty(doc.followUp)
                let inputTypes = this.state
                _.each(docLoaded, (item, key) => {
                    inputTypes[key] = item
                })

                this.setState({
                    ...inputTypes
                })
                if (doc.atLevel == 'Front Desk' && docLoaded.completed == true) {
                    this.setState({ moveNext: true, admissionUsers })
                }


                this.setState({ registrationUserId: doc.registrationUserId, admissionUserId: doc.admissionUserId })

                setTimeout(async () => {
                    await this.getAllSUbRatings(docLoaded.rating);
                    this.setState({ screenLoad: false, rating: docLoaded.rating, subRating: docLoaded.subRating, leadStatus: docLoaded.leadStatus }, () => {
                        form.setFieldsValue({ ...docLoaded });
                        if (docLoaded.isStudentEligible == true) {
                            form.setFieldsValue({ studentEligibility: "Yes" })
                        } else if (docLoaded.isStudentEligible == false) {
                            form.setFieldsValue({ studentEligibility: "Yes" })
                        }
                    })
                }, 1000)

                this.setState({ info: doc, followUpDataDisplay: followUpDataDisplay, followupRequired })
            } else {

                this.setState({ screenLoad: false })
            }
        } catch (e) {
            console.log(e)
            this.setState({ screenLoad: false })
        }
    }
    calback = val => {
        let cloneCourse = _.clone(this.state.course);
        let findCourse = _.find(cloneCourse, item => {
            return item._id == val._id
        })


        if (findCourse) {
            if (val.pathwayName) {
                findCourse.pathwayName = val.pathwayName

            } else {
                notification.success({
                    message: 'Success',
                    description: 'Course already exists.'
                })
            }

        } else {
            cloneCourse.push(val)
            this.setState({
                course: cloneCourse
            })
        }
    }

    tbCallback = (id, obj) => {
        const cloneCourse = this.state.course.map(course => course._id == id ? obj : course)
        this.setState({
            course: cloneCourse
        })
    }

    closeFollowUp = () => {
        this.setState({ visible: false })
    }

    removeCourse = item => {
        let cloneCourse = _.clone(this.state.course)
        cloneCourse = _.reject(cloneCourse, itemV => {
            return item._id == itemV._id
        })
        this.setState({
            course: cloneCourse
        })
    }

    fundRequirement = item => {
        let keyObj = {
            _id: this.state.inquiryId,
            pathwayId: item.pathwayId,
            courseId: item._id
        }
        Request.fundRequirementApi(keyObj)
    }

    courseFactSheet = item => {
        Request.courseFactSheetApit(item._id)
    }

    sendCourseFactSheetLink = async (item) => {
        let studentId = this.state.inquiryId;
        await Request.sendCourseFactSheetLink({
            courseId: item._id,
            studentId
        });
    }

    viewUniversityFiles = item => {
        this.props.dispatch(getUrlPushWrapper('report.libraryReport', { universityId: item.universityId }))
    }

    courseQuotation = item => {
        Request.courseQuotationApi(this.state.inquiryId, item)
    }
    downloadCourseFactSheet = async item => {
        this.props.dispatch(showLoader())
        let resp = await Request.downloadCourseFactSheet(item)
        this.props.dispatch(hideLoader())
    }

    addReference = () => {
        if (!this.state.name) {
            notification.success({
                message: 'Warning',
                description: 'Enter Reference Name'
            })
            return
        }
        if (!this.state.mobile) {
            notification.success({
                message: 'Warning',
                description: 'Enter Reference Mobile No'
            })
            return
        }
        if (!this.state.country) {
            notification.success({
                message: 'Warning',
                description: 'Select Reference Country'
            })
            return
        }
        let key = 0
        if (this.state.reference.length) {
            key = this.state.reference[this.state.reference.length - 1].key + 1
        }
        let Obj = {
            key: key,
            country: this.state.country,
            name: this.state.name,
            mobile: this.state.mobile
        }
        let cloneRef = _.clone(this.state.reference)
        cloneRef.push(Obj)
        this.setState({
            name: null,
            mobile: null,
            country: null,
            reference: cloneRef
        })
    }
    removeRef = item => {
        let cloneRef = _.clone(this.state.reference)
        cloneRef = _.reject(cloneRef, itemV => {
            return item.key == itemV.key
        })
        this.setState({
            reference: cloneRef
        })
    }
    showDrawer = () => {
        this.setState({
            visible: true
        })
    }

    showPreferenceDrawer = () => {
        this.setState({
            prferenceDrawer: true
        })
    }

    closePreferenceDrawer = () => {
        this.setState({
            prferenceDrawer: false
        })

    }


    removeReferenceStudent = (index) => {
        this.setState((prevState) => {
            const referenceList = [...prevState.referenceList]; // Create a shallow copy
            referenceList.splice(index, 1); // Remove the item at the specified index
            return { referenceList }; // Return the updated state
        });
    }


    loadDealingCountries = () => {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
        };
        Request.getDealingCountries({ ...params }).then((resp) => {
            let dealingPhoneCodes = [];
            let dealingCountryPhoneCodes = [];
            let dealingCountryFieldArr = [];
            resp.data = resp.data.reduce((temp, vv) => {
                dealingCountryFieldArr.push({ _id: vv._id, display: vv.countryName });
                if (vv.countryPhoneCode) {
                    dealingCountryPhoneCodes[vv._id] = vv.countryPhoneCode;
                    dealingPhoneCodes.push(vv.countryPhoneCode);
                }
                temp.push({ ...vv });
                return temp;
            }, []);
            this.setState({ dealingCountryArr: resp.data, dealingCountryFieldArr: dealingCountryFieldArr, dealingPhoneCodes: dealingPhoneCodes, dealingCountryPhoneCodes: dealingCountryPhoneCodes });
        })
    }

    loadAllCountries = () => {

        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        }

        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    resp.data = resp.data.reduce((temp, vv) => {
                        vv.display = vv.countryName
                        temp.push(vv)
                        return temp
                    }, [])
                    this.setState({ countryArr: resp.data })
                }
            })
            .catch(err => {
            })
    }

    loadSuggestedCourses = async () => {
        let { inquiryId } = this.state
        let params = {
            inquiryId: inquiryId
        }
        let data = await Request.getAllSuggestedCourse(params);
        this.setState({ suggestedCourses: data.data })

    }

    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id');
        let tabId = searchParams.get('tab');
        if (tabId) {
            this.setState({ current: tabId });
        }
        if (inquiryId) {
            this.setState({ inquiryId: inquiryId })
            this.setFormValues(inquiryId)
        }
        let localUser = JSON.parse(localStorage.getItem("user"));

        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isRegistration: true,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
            userId: localUser._id,
        });
        this.setState({ allUsers });
        this.getAllRatings();
        this.getAllLeadStatuses();
        this.getAllMaritalStatus();

    }

    closeNotEligibleDrawer = () => {
        this.setState({})
    }


    handleReferenceSubmit = () => {
        let { form } = this.props;
        let referenceFromValues = form.getFieldsValue(['referenceStudentName', 'referenceCountryCode', 'referenceMobile', 'referenceInterestedIn'])
        if (!referenceFromValues.referenceStudentName) {
            notification.error({
                message: 'Expect Reference Student Name!'
            })
            return
        }
        if (!referenceFromValues.referenceCountryCode) {
            notification.error({
                message: 'Expect Reference Country Code!'
            })
            return
        }
        if (!referenceFromValues.referenceMobile) {
            notification.error({
                message: 'Expect Reference Mobile Number!'
            })
            return
        }
        if (!referenceFromValues.referenceInterestedIn) {
            notification.error({
                message: 'Expect Reference Interested In!'
            })
            return
        }
        let referenceList = this.state.referenceList
        referenceList.push(referenceFromValues)
        this.setState({ referenceList, showReferFriend: false }, () => {
            this.props.form.setFieldsValue({
                referenceStudentName: null,
                referenceCountryCode: null,
                referenceMobile: null,
                referenceInterestedIn: null
            })
        });

    }

    getAllRatings = async () => {
        let response = await Request.getRatingsDetails({
            results: 1000,
            count: 1000
        })
        this.setState({ parentRatings: response.data })
    }

    getAllLeadStatuses = async () => {
        let response = await Request.getLeadStatusDetails({
            results: 1000,
            count: 1000
        });
        if (response && response.data) {
            const allowedLeadStatuses = response.data.filter(ls => ls.desk && ls.desk.includes('Front Desk'));
            this.setState({ leadStatuses: allowedLeadStatuses });
        }
    }

    getAllSUbRatings = async (id) => {
        let response = await Request.getSubRatingsDetails({
            results: 1000,
            count: 1000,
            parentRatingId: id
        })
        this.setState({ subRatings: response.data })
    }

    getAllMaritalStatus = async () => {
        let response = await Request.getMaritalStatusDetails({
            results: 1000,
            count: 1000
        })
        let maritalObject = [];
        response.data && response.data.map((marital) => {
            maritalObject.push(marital.maritalStatus)
        })
        this.setState({ maritalArr: maritalObject })
    }

    render() {
        const { submitting, dispatch } = this.props
        const { countryArr, current, maritalArr, selectCourseIds, info, screenLoad, followUpDataDisplay, followupRequired } = this.state
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props;
        let followUpDataShowForm = this.state.followUpDataDisplay && this.state.followUpDataDisplay.details ? false : true;
        // Steps Test Section Start

        const marriedForm = {
            fields: [
                {
                    label: 'Family Accompanying ',
                    key: 'accompanying',
                    required: this.state.maritalStatus == 'Married' ? true : false,
                    width: '100%',
                    type: 'select',
                    options: ['Yes', 'No'],
                    defaultValue: { key: 'Please Select' },
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            accompanying: v
                        })
                    }
                },
                {
                    label: 'How many Children Less then 5 year of age',
                    required: this.state.maritalStatus == 'Married' ? true : false,
                    key: 'howManyChildLessThanFiveYearOld',
                    placeholder: 'How many Children Less then 5 year of age',
                    width: '100%',
                    type: 'select',
                    options: [1, 2, 3, 4, 5],
                    defaultValue: { key: 'Please Select' },
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            howManyChildLessThanFiveYearOld: v
                        })
                    }
                },
                {
                    label: 'Children Accompanying ',
                    key: 'accompanyingLessThanFiveYearOld',
                    required: this.state.maritalStatus == 'Married' ? true : false,
                    type: 'select',
                    options: ['Yes', 'No'],
                    defaultValue: { key: 'Please Select' },
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            accompanyingLessThanFiveYearOld: v
                        })
                    }
                },
                {
                    label: 'How many Children over 5 year of age',
                    required: this.state.maritalStatus == 'Married' ? true : false,
                    key: 'howManyChildMoreThanFiveYearOld',
                    placeholder: 'How many Children over 5 year of age',
                    width: '100%',
                    type: 'select',
                    options: [1, 2, 3, 4, 5],
                    defaultValue: { key: 'Please Select' },
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            howManyChildMoreThanFiveYearOld: v
                        })
                    }
                },
                // {
                //     label: 'Accompanying ',
                //     key: 'accompanyingMoreThanFiveYearOld',
                //     type: 'select',
                //     required: this.state.maritalStatus == 'Married' ? true : false,
                //     options: ['Yes', 'No'],
                //     defaultValue: { key: 'Please Select' },
                //     onChange: v => {
                //         this.props.form.setFieldsValue({
                //             accompanyingMoreThanFiveYearOld: v
                //         })
                //     }
                // }
            ]
        }

        const courseColumns = [
            {
                title: 'Course Name',
                dataIndex: 'courseName',
                key: 'courseName'
            },
            {
                title: 'University',
                dataIndex: 'universityInstitutionName',
                key: 'universityInstitutionName'
            },
            {
                title: 'Campus',
                dataIndex: 'mainCampus',
                key: 'mainCampus',
                render: (val, record) => {
                    const defaultCampus = record.campusId ? record.campusId : null;
                    return (
                        record.mainCampus && record.mainCampus.length > 0 ?
                            <div style={{ display: "flex" }}>
                                <Select defaultValue={{ key: defaultCampus }}
                                    style={{ width: 150 }}
                                    labelInValue
                                    showSearch={true}
                                    filterOption={(inputValue, option) =>
                                        option.props.children
                                            .toString()
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    onChange={(campus) => {
                                        if (campus) {
                                            record.campusId = campus.key
                                            record.campusName = campus.label
                                        } else {
                                            record.campusId = null
                                            record.campusName = null
                                        }
                                        this.tbCallback(record._id, record)
                                    }}>
                                    <Option value={null}>Select Campus</Option>
                                    {record.mainCampus.map((item, key) => {
                                        let campusId = '';

                                        if (item._id) {
                                            if (typeof item._id === 'object' && item._id.$oid) {
                                                campusId = item._id.$oid; // when MongoDB gives ObjectId object
                                            } else {
                                                campusId = item._id; // normal string _id
                                            }
                                        }
                                        return (
                                            <Option key={key} value={campusId}>{item.campusName}</Option>
                                        )
                                    })}
                                </Select>
                            </div> : null
                    )
                },
            },
            {
                title: 'PathWay',
                dataIndex: 'pathwayName',
                key: 'pathwayName'
            },
            {
                title: 'Fees/Duration',
                width: 150,
                key: 'tutionFee',
                dataIndex: 'tutionFee',
                render: (val, record) => {
                    return (
                        <div>
                            <span>{record.tutionFee} /</span>
                            <span>{record.courseDuration}</span>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                fixed: 'right',
                width: 150,
                render: (item, record) => (
                    <React.Fragment>
                        <Tooltip title="Remove Course">
                            <Button
                                className={styles.btn}
                                type="danger"
                                shape="circle"
                                onClick={() => {
                                    this.removeCourse(item)
                                }}
                                icon="delete"
                            />
                        </Tooltip>
                        <Tooltip title="Fund Requirement">
                            <Button
                                type="success"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.fundRequirement(item)
                                }}
                                icon="dollar"
                            />
                        </Tooltip>
                        <Tooltip title="Course Fact Sheet">
                            <Button
                                type="warning"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.courseFactSheet(item)
                                }}
                                icon="file"
                            />
                        </Tooltip>
                        <Tooltip title="Course Quotation">
                            <Button
                                type="warning"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.courseQuotation(item)
                                }}
                                icon="file"
                            />
                        </Tooltip>
                        <Tooltip title="Download Fact Sheet">
                            <Button
                                type="warning"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.downloadCourseFactSheet(item)
                                }}
                                icon="download"
                            />
                        </Tooltip>
                        <Tooltip title="View Files">
                            <Button
                                type="warning"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.viewUniversityFiles(item)
                                }}
                                icon="file"
                            />
                        </Tooltip>
                        <Tooltip title="Send course link">
                            <Button
                                type="warning"
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                    this.sendCourseFactSheetLink(item)
                                }}
                            ><FaWhatsappSquare /></Button>
                        </Tooltip>
                    </React.Fragment>
                )
            }
        ]

        const inputTypes = {
            fields: [
                {
                    label: 'Date',
                    key: 'date',
                    type: 'date',
                    required: followupRequired ? true : false
                },
                {
                    label: 'Details',
                    key: 'detail',
                    type: 'textArea',
                    rows: 10,
                    required: followupRequired ? true : false

                },
                // {
                //     label: 'FollowUp Type',
                //     key: 'followUpType',
                //     type: 'select',
                //     options: ['Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town', 'Active'],
                //     placeholder: 'Select followUp Type',
                //     required: followupRequired ? true : false,
                //     onChange: v => {
                //         this.props.form.setFieldsValue({
                //             followUpType: v
                //         })
                //     }
                // }
            ]
        }

        const referFriendColumns = [
            {
                title: 'Student Name',
                key: 'referenceStudentName',
                dataIndex: 'referenceStudentName'
            },
            {
                title: 'Country Code',
                key: 'referenceCountryCode',
                dataIndex: 'referenceCountryCode'
            },
            {
                title: 'Mobile Number',
                key: 'referenceMobile',
                dataIndex: 'referenceMobile'
            },
            {
                title: 'Interested In',
                key: 'referenceInterestedIn',
                dataIndex: 'referenceInterestedIn'
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record, index) => (
                    <Tooltip title="Remove Student">
                        <Button shape="circle" icon="delete" size="small" onClick={() => this.removeReferenceStudent(index)} />
                    </Tooltip>
                )
            }
        ]


        const referAFriendSchema = {
            fields: [
                {
                    label: "Full Name",
                    key: "referenceStudentName",
                    prefixComp: <h3 style={{ margin: '10px 2px' }}>Basic information as per passport </h3>,
                },
                {
                    label: 'Country Code',
                    key: 'referenceCountryCode',
                    type: 'select',
                    options: this.state.dealingPhoneCodes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ referenceCountryCode: v })
                    }
                },
                {
                    label: 'Mobile Number',
                    key: 'referenceMobile',
                },
                {
                    label: 'Interested In',
                    key: 'referenceInterestedIn',
                    type: 'select',
                    options: [{ id: 'STUDENT', display: 'Study Abroad' }, { id: 'IELTS', display: 'IELTS/PTE' }, { id: 'VISITOR', display: 'Visitor Visa' }],
                    onChange: v => {
                        this.props.form.setFieldsValue({ referenceInterestedIn: v })
                    }
                }
            ]
        }

        const steps = [
            {
                title: 'Summary',
                content: <>
                    <h3>Summary Notes For Counsellors</h3>
                    <div style={{ border: '1px solid black' }}>
                        <table width={"100%"} style={{ borderCollapse: 'collapse', paddingLeft: '20px', padding: '30px 30px' }}>
                            <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>Preferred Country:</h3>
                            {
                                info && info.totalPreference && info.totalPreference.length ?
                                    info.totalPreference.map((preference) => (
                                        <div style={{ marginTop: 10, marginLeft: 10 }}>

                                            <tr>
                                                {/* <${preference && preference.city?preference.city.trim():""}> */}
                                                <td>{`${preference && preference.country ? preference.country : ""}${preference && preference.city ? `<${preference && preference.city ? preference.city.trim() : ""}>` : ""}`}</td>
                                            </tr>
                                        </div>
                                    ))
                                    : null
                            }

                            {
                                info && info.haveEnglishTestScore ?
                                    <div style={{ marginTop: 10, marginLeft: 10 }}>
                                        <hr />
                                        <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>English Test Score:</h3>
                                        {
                                            info.haveEnglishTestScore === "false" ? "Will Plan Soon" :
                                                <table width={"100%"}>
                                                    <thead>
                                                        <tr>
                                                            <th>Test Type</th>
                                                            <th>Overall</th>
                                                            <th>Listening</th>
                                                            <th>Speaking</th>
                                                            <th>Reading</th>
                                                            <th>Writing</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{info.testType ? info.testType : "NA"}</td>
                                                            <td>{info && info.profile && info.profile.overAllScore ? info.profile.overAllScore : "NA"}</td>
                                                            <td>{info && info.profile && info.profile.listening ? info.profile.listening : "NA"}</td>
                                                            <td>{info && info.profile && info.profile.speaking ? info.profile.speaking : "NA"}</td>
                                                            <td>{info && info.profile && info.profile.reading ? info.profile.reading : "NA"}</td>
                                                            <td>{info && info.profile && info.profile.writing ? info.profile.writing : "NA"}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                        }
                                    </div>
                                    : null
                            }

                            {/* Qualification */}
                            {
                                info && info.profile && info.profile.newQualification && info.profile.newQualification.length ?
                                    <div style={{ marginTop: 10, marginLeft: 10 }}>
                                        <hr />
                                        <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>Qualifications:</h3>
                                        <table width={"100%"}>
                                            <thead>
                                                <tr>
                                                    <th>Qualification</th>
                                                    <th>Passing Year</th>
                                                    <th>Stream</th>
                                                    <th>Grading System</th>
                                                    <th>Score</th>
                                                    <th>Institution</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    info.profile.newQualification.map((qualification) => (
                                                        <tr>
                                                            <td>{qualification.qualification ? qualification.qualification : "-"}</td>
                                                            <td>{qualification.to ? moment(qualification.to, "MM-YYYY").format('YYYY') : "-"}</td>
                                                            <td>{qualification.stream ? qualification.stream : "-"}</td>
                                                            <td>{qualification.gradingSystem ? qualification.gradingSystem : "-"}</td>
                                                            <td>{qualification.score ? qualification.score : "-"}</td>
                                                            <td>{qualification.qualification === "X" || qualification.qualification === "XII" ? qualification.board ? qualification.board : "-" : qualification.university ? qualification.university : "-"}</td>

                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    : null
                            }

                            {
                                info && info.profile && info.profile.jobDetails && info.profile.jobDetails.length ?
                                    <div style={{ marginTop: 10, marginLeft: 10 }}>
                                        <hr />
                                        <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>Work Experience:</h3>
                                        <table width={"100%"}>
                                            <thead>
                                                <tr>
                                                    <th>Position</th>
                                                    <th>Company</th>
                                                    <th>Contact Person</th>
                                                    <th>Contact Person Number</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    info.profile.jobDetails.map((job) => (
                                                        <tr>
                                                            <td>{job.jobTitle ? job.jobTitle : ""}</td>
                                                            <td>{job.company ? job.company : ""}</td>
                                                            <td>{job.contactPerson ? job.contactPerson : ""}</td>
                                                            <td>{job.phone ? job.phone : ''}</td>
                                                            <td>{job.from ? moment(job.from, "DD-MM-YYYY").format('DD-MMM-YYYY') : ""}</td>
                                                            <td>{job.to ? moment().isSame(job.to, "DD-MM-YYYY") ? moment(job.to, "DD-MM-YYYY").format("DD-MM-YYYY") : "Current" : ""}</td>
                                                        </tr>
                                                        // <p>{`Position:${job.jobTitle ? job.jobTitle : ""} Company:${job.company ? job.company : ""} Contact Person:${job.contactPerson ? job.contactPerson : ""} Contact Number: ${job.phone ? job.phone : ''} Start Date ${job.from ? moment(job.from, "DD-MM-YYYY").format('DD-MMM-YYYY') : ""} to ${job.to ? moment(job.to, "DD-MM-YYYY").format("DD-MM-YYYY") : ""}`}</p>
                                                    ))
                                                }
                                            </tbody>
                                        </table>

                                    </div>
                                    : null
                            }

                            {
                                info && info.gapTotal ?
                                    <div style={{ marginTop: 10, marginLeft: 10 }}>
                                        <hr />
                                        <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>Education Gap:</h3>
                                        <tr>
                                            <td>{info.gapTotal ? info.gapTotal : "No Gap"}</td>
                                        </tr>
                                    </div>

                                    : null
                            }

                            {
                                info && info.totalPreference && info.totalPreference.length ? <><hr />
                                    {
                                        info.totalPreference.map((preference) => (
                                            <div style={{ marginTop: 10, marginLeft: 10 }}>
                                                <h3 style={{ color: '#FDCB0A', fontWeight: "bold" }}>Eligibility With Available Data:</h3>
                                                <tr>
                                                    <td style={{ fontSize: '13px', fontWeight: 'bold' }}>{`${preference && preference.country ? preference.country : ""}`}:- {this.state.suggestedCourses.find(x => x.countryId === preference.countryId) ? <a onClick={() => this.showDrawer()}>{`Yes [Show Options]`}</a> : "No"} </td>
                                                </tr>
                                            </div>
                                        ))
                                    }

                                </>
                                    : null

                            }
                        </table>
                    </div>
                </>
            },
            {
                title: 'Choose Rating',
                content: (
                    <div>

                        {/* ===== QUALITY RATING ===== */}
                        <Form.Item>
                            <Row>
                                <Col span={8} className={styles.radioLabel}>
                                    Quality Rating * :
                                </Col>
                                <Col span={16}>
                                    <Select
                                        style={{ width: '350px' }}
                                        value={this.state.qualityRating}
                                        placeholder="Select Quality Rating"
                                        onChange={value => this.setState({ qualityRating: value })}
                                    >
                                        {this.getAllowedQualityOptions().map(opt => (
                                            <Option key={opt} value={opt}>
                                                {opt}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Popover style={{ width: '10px', justifyContent: 'center' }} content={content['qualityRating']}><HiInformationCircle style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: '#058ed9' }} /></Popover>
                                </Col>
                            </Row>
                        </Form.Item>


                        {/* ===== EXISTING RATING FIELD ===== */}
                        <Form.Item>
                            <Row>
                                <Col span={8} className={styles.radioLabel}>
                                    Conversion Rating * :
                                </Col>
                                <Col span={16}>
                                    <Select
                                        style={{ width: '350px' }}
                                        showSearch={true}
                                        required
                                        placeholder="Please Choose Conversion Rating"
                                        value={this.state.rating}
                                        onChange={item => {
                                            this.getAllSUbRatings(item)
                                            this.setState({ rating: item, subRating: '' })
                                        }}
                                    >
                                        {this.state.parentRatings.map(item => (
                                            <Option key={item._id} value={item._id}>
                                                {item.ratingName}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Popover style={{ width: '10px' }} content={content['conversionRating']}><HiInformationCircle style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: '#058ed9' }} /></Popover>
                                </Col>
                            </Row>
                        </Form.Item>

                        {/* ===== SUB RATING ===== */}
                        <Form.Item>
                            <Row>
                                <Col span={8} className={styles.radioLabel}>
                                    Rating Tag * :
                                </Col>
                                <Col span={16}>
                                    <Select
                                        style={{ width: '350px' }}
                                        showSearch={true}
                                        required
                                        placeholder="Please Choose Tag"
                                        value={this.state.subRating || ''}
                                        onChange={item => this.setState({ subRating: item })}
                                    >
                                        {this.state.subRatings.map(item => (
                                            <Option key={item._id} value={item._id}>
                                                {item.ratingName}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Popover style={{ width: '10px', marginTop: 10 }} content={content['status']}><HiInformationCircle style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: '#058ed9' }} /></Popover>
                                </Col>
                            </Row>
                        </Form.Item>

                        {/* ===== LEAD STATUS ===== */}
                        <Form.Item>
                            <Row>
                                <Col span={8} className={styles.radioLabel}>
                                    Lead Status * :
                                </Col>
                                <Col span={16}>
                                    <Select
                                        style={{ width: '350px' }}
                                        showSearch={true}
                                        required
                                        placeholder="Please Choose Lead Status"
                                        value={this.state.leadStatus || undefined}
                                        onChange={item => this.setState({ leadStatus: item })}
                                    >
                                        {this.state.leadStatuses.map(item => (
                                            <Option key={item._id} value={item._id}>
                                                {item.statusName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                        </Form.Item>

                        {/* ===== MARITAL STATUS ===== */}
                        <Form.Item>
                            <Row>
                                <Col span={8} className={styles.radioLabel}>
                                    Marital Status * :
                                </Col>
                                <Col span={16}>
                                    <RadioGroup
                                        options={this.state.maritalArr}
                                        required={true}
                                        onChange={v => {
                                            this.setState({ maritalStatus: v.target.value })
                                            this.props.form.setFieldsValue({
                                                maritalStatus: v.target.value
                                            })
                                        }}
                                        value={this.state.maritalStatus}
                                    />
                                </Col>
                            </Row>
                        </Form.Item>

                        {this.state.maritalStatus === 'Married' ? (
                            <GetAllFormFields
                                inputSchema={marriedForm}
                                getFieldDecorator={getFieldDecorator}
                            />
                        ) : null}
                    </div>
                )
            }
            ,
            {
                title: 'Choose Course',
                content: <div className={[styles.marginTop10, styles.courseDiv]}>

                    <Button
                        type="default"
                        onClick={() => this.showDrawer()}
                        style={{ marginBottom: 10, background: 'green', color: "#fff" }}>
                        Click here to choose a course..
                    </Button>
                    <Button type="default"
                        onClick={() => this.showPreferenceDrawer()}
                        style={{ marginBottom: 10, marginLeft: 30, background: 'blue', color: "#fff" }}>
                        Change Country Preference
                    </Button>
                    {this.state.prferenceDrawer ?
                        <CountryPreference inquiryId={this.state.inquiryId} onClose={this.closePreferenceDrawer} />
                        : null}
                    {/* {this.state.visible ? (
                        <CourseFinder
                            inquiryId={this.state.inquiryId}
                            callback={this.calback}
                            onClose={this.closeFollowUp}
                            removeCourse={this.removeCourse}
                            selectCourseIds={this.state.course}
                        />
                    ) : (
                        ''
                    )} */}

                    <Table
                        bordered={true}
                        columns={courseColumns}
                        dataSource={this.state.course}
                        pagination={false}
                    />
                </div>
            },
            {
                title: 'First Counselling Notes',
                content: <div>
                    {
                        followUpDataShowForm ?
                            <div style={{ marginTop: '10px' }}>
                                <div>
                                    <Icon type={'calendar'} />
                                    First Counselling Notes
                                </div>

                                <GetAllFormFields
                                    apiurl={API_URL}
                                    inputSchema={inputTypes}
                                    getFieldDecorator={getFieldDecorator}
                                />

                                <Row>
                                    <Col span={8} />
                                    <Col span={8} />
                                </Row>
                            </div>
                            : null
                    }
                    {
                        followUpDataDisplay && <div style={{ marginBottom: '15px', marginTop: '15px' }}>
                            <Row>
                                <Col span={8}>
                                    <b>FollowUp
                                        Date
                                        :</b> {followUpDataDisplay && moment(followUpDataDisplay.followUpDate).format('DD-MM-YYYY')}
                                </Col>

                                <Col span={8}>
                                    <b>FollowUp Type :</b> {followUpDataDisplay && followUpDataDisplay.followUpType}
                                </Col>
                                <Col span={8}>
                                    <b>Detail :</b> {followUpDataDisplay && followUpDataDisplay.details}
                                </Col>
                            </Row>
                        </div>

                    }
                    <Row gutter={16}>
                        <Col span={8}>
                            Refer A Friend? * :
                        </Col>
                        <Col span={12}>
                            <Select value={this.state.showReferFriendSection} onChange={(v) => this.setState({ showReferFriendSection: v })} style={{ width: '100%' }}>
                                <Option value={true}>Yes</Option>
                                <Option value={false}>No</Option>
                            </Select>
                        </Col>
                    </Row>
                    {
                        this.state.showReferFriendSection ?
                            <div style={{ marginTop: 10 }}>
                                <Card title="Refer a friend">
                                    <div className={"referenceItem"}>
                                        <a onClick={() => this.setState({ showReferFriend: true })}>Click to add</a>
                                        <Modal
                                            title="Reference Details"
                                            visible={this.state.showReferFriend}
                                            onCancel={() => this.setState({ showReferFriend: false })}
                                            onOk={() => this.setState({ showReferFriend: false })}
                                            footer={[<Button
                                                type="primary"
                                                onClick={() => this.handleReferenceSubmit()}
                                                style={{ marginBottom: 10 }}
                                                loading={this.props.loading}>
                                                SAVE
                                            </Button>]}
                                        >
                                            <Form>
                                                <GetAllFormFields apiurl={API_URL} inputSchema={referAFriendSchema} getFieldDecorator={getFieldDecorator} />
                                            </Form>
                                        </Modal>
                                    </div>
                                    <Row style={{ marginTop: 40 }}>
                                        <Col span={24}>
                                            <Table
                                                bordered={true}
                                                style={{ width: '100%' }}
                                                columns={referFriendColumns}
                                                dataSource={this.state.referenceList}
                                                pagination={false}
                                            />
                                        </Col>
                                    </Row>
                                    <br />
                                    <div className={"referenceItem refer-friend-section"}>
                                        <div>
                                            <Row>
                                                <Col span={24}>Name </Col>
                                                <Col span={24}>
                                                    <Input
                                                        value={this.state.name}
                                                        onChange={(ei) => {
                                                            this.setState({ name: ei.target.value });
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row>
                                                <Col span={24}>Mobile No </Col>
                                                <Col span={24}>
                                                    <InputNumber
                                                        value={this.state.mobile}
                                                        style={{ width: 200 }}
                                                        max="10"
                                                        min="10"
                                                        onChange={(ei) => {
                                                            this.setState({ mobile: ei });
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row>
                                                <Col span={24}>Country </Col>
                                                <Col span={24}>
                                                    <Select
                                                        placeholder="Select Country"
                                                        optionFilterProp="children"
                                                        showSearch={true}
                                                        value={
                                                            this.state.country1
                                                                ? this.state.country1._id
                                                                : undefined
                                                        }
                                                        onChange={(ei) => {
                                                            let singleCountry = _.find(
                                                                this.state.countryArr,
                                                                (item) => {
                                                                    return item._id == ei;
                                                                }
                                                            );
                                                            this.setState({
                                                                country1: singleCountry,
                                                                city: null,
                                                            });
                                                        }}
                                                    >
                                                        {this.state.countryArr.map((val, index) => {
                                                            return (
                                                                <Option key={index} value={val._id}>
                                                                    {val.countryName}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Button
                                                style={{
                                                    marginBottom: "9px",
                                                    marginTop: "17px",
                                                    height: "30px",
                                                }}
                                                size={"small"}
                                                type="primary"
                                                onClick={() => {
                                                    if (!this.state.country1) {
                                                        return notification.error({
                                                            message: "Choose Country",
                                                        });
                                                    }

                                                    if (!this.state.name) {
                                                        return notification.error({
                                                            message: "Enter name",
                                                        });
                                                    }
                                                    if (!this.state.mobile) {
                                                        return notification.error({
                                                            message: "Enter mobile",
                                                        });
                                                    }

                                                    if (
                                                        (this.state.country1 && this.state.name,
                                                            this.state.mobile)
                                                    ) {
                                                        let tt = this.state.totalData;
                                                        tt.push({
                                                            country: this.state.country1,
                                                            name: this.state.name,
                                                            mobile: this.state.mobile,
                                                        });
                                                        this.setState(
                                                            {
                                                                totalData: tt,
                                                                country1: null,
                                                                name: null,
                                                                mobile: null,
                                                            },
                                                            () => { }
                                                        );
                                                    }
                                                }}
                                            >
                                                ADD
                                            </Button>
                                        </div>
                                    </div>

                                    <Row style={{ marginTop: 40, display: "none" }}>
                                        <Col span={24}>
                                            <Table
                                                bordered={true}
                                                rowKey={(x) => x.mobile}
                                                columns={refColumns}
                                                dataSource={this.state.totalData || []}
                                                pagination={false}
                                            />
                                        </Col>

                                        <Col span={24} style={{ marginTop: 10 }}>
                                            <h4>With SMS</h4>
                                            <Select
                                                allowClear
                                                showSearch={true}
                                                style={{ width: 200 }}
                                                placeholder="With SMS"
                                                defaultValue={this.state.withSMS}
                                                onChange={(v) => {
                                                    this.setState({
                                                        withSMS: v,
                                                    });
                                                }}
                                            >
                                                <Option value="With SMS">With SMS</Option>
                                                <Option value="Without SMS">Without SMS</Option>
                                            </Select>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>

                            : null
                    }
                </div>
            }
        ]



        // Steps Test Section End

        const maritalOption = maritalArr



        const inputSchma = {
            fields: [
                {
                    label: "Rating",
                    key: "rating",
                    type: "select",
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.ratingName,
                    options: this.state.parentRatings ? this.state.parentRatings : {},
                    onChange: (v) => {
                        this.getAllSUbRatings(v);
                        this.props.form.setFieldsValue({ rating: v });
                    },
                },
                {
                    label: "Sub Rating",
                    key: "subRating",
                    type: "select",
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.ratingName,
                    options: this.state.subRatings ? this.state.subRatings : {},
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ subRating: v });
                    },
                },
            ]
        }

        const submitFormLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 10, offset: 7 },
                md: { span: 12, offset: 8 }
            }
        }

        const refColumns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Mobile',
                dataIndex: 'mobile',
                key: 'mobile'
            },
            {
                title: 'Country',
                dataIndex: 'country',
                key: 'country'
            },
            {
                title: 'Action',
                key: 'operation',
                fixed: 'right',
                width: 150,
                render: (item, record) => (
                    <React.Fragment>
                        <Tooltip title="Remove Reference">
                            <Button
                                type="danger"
                                shape="circle"
                                onClick={() => {
                                    this.removeRef(item)
                                }}
                                icon="delete"
                            />
                        </Tooltip>
                    </React.Fragment>
                )
            }
        ]



        const refModule = (
            <Card className={styles.marginTop10} title="Reference">
                <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col span={6}>
                        <Row>
                            <Col span={24}>Name </Col>
                            <Col span={24}>
                                <Input
                                    value={this.state.name}
                                    onChange={ei => {
                                        this.setState({ name: ei.target.value })
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row>
                            <Col span={24}>Mobile No </Col>
                            <Col span={24}>
                                <InputNumber
                                    value={this.state.mobile}
                                    style={{ width: 200 }}
                                    onChange={ei => {
                                        this.setState({ mobile: ei })
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <Row>
                            <Col span={24}>Country </Col>
                            <Col span={24}>
                                <Select
                                    style={{ width: 120 }}
                                    value={
                                        this.state.country ? this.state.country : 'Please Select'
                                    }
                                    onChange={item => {
                                        this.setState({ country: item })
                                    }}>
                                    {countryArr.map(item => (
                                        <Option key={item._id} value={item.display}>
                                            {item.display}
                                        </Option>
                                    ))}
                                </Select>

                                <Button
                                    size={'small'}
                                    style={{ marginLeft: 20 }}
                                    onClick={() => {
                                        this.addReference()
                                    }}>
                                    Add
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={4} />
                </Row>

                <Row style={{ marginTop: 40 }}>
                    <Col span={24}>
                        <Table
                            bordered={true}
                            columns={refColumns}
                            dataSource={this.state.reference}
                            pagination={false}
                        />
                    </Col>
                </Row>
            </Card>
        )

        return (
            <PageHeaderWrapper
                title={info && info.studentName ? `Counselling of ${info.studentName}` : 'Counselling Screen'}>
                {this.state.visible ? (
                    <CourseFinder
                        inquiryId={this.state.inquiryId}
                        callback={this.calback}
                        onClose={this.closeFollowUp}
                        removeCourse={this.removeCourse}
                        selectCourseIds={this.state.course}
                    />
                ) : (
                    ''
                )}
                {/* Test Section Start */}
                <Form onSubmit={this.handleSubmit} hideRequiredMark>
                    {
                        info && info._id ? <div style={{ marginBottom: 10 }}>
                            <StudentHeader
                                info={this.state.inquiryId}
                                data={info}
                                done={() => {
                                    dispatch(getUrlPushWrapper('desk.counselling'))
                                }}
                                dispatch={this.props.dispatch}
                            />
                        </div> : null
                    }
                    {
                        info ? <Card bordered={true} style={{ marginBottom: 10 }}>
                            <StudentInfo
                                info={info}

                            />
                        </Card> : null
                    }
                    <Card bordered={true}>
                        <Steps current={current}>
                            {steps.map(item => (
                                <Step status={this.state.stepsStatus} key={item.title} title={item.title} />
                            ))}
                        </Steps>
                        <div style={{ marginTop: 30 }} className='steps-content'>{steps[current].content}</div>
                        <div style={{ marginTop: 10 }} className='steps-action'>
                            {
                                current < steps.length - 1 && (
                                    <Button type='primary' onClick={() => this.next()}>
                                        {current === 0 ? "Next" : "Save & Next"}
                                    </Button>
                                )}
                            {
                                current === steps.length - 1 && (
                                    <Button type='primary' htmlType="submit">Update</Button>
                                )}
                            {
                                current > 0 && (
                                    <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
                                        Previous
                                    </Button>
                                )}
                        </div>

                    </Card>
                    {this.state.moveNext ? (
                        <Card>
                            <Col span={8} >
                                <Select
                                    style={{ width: '200px' }}
                                    showSearch={true}
                                    mode="multiple"
                                    placeholder="Please Choose Registrar"
                                    value={
                                        this.state.registrationUserId ? this.state.registrationUserId : []
                                    }
                                    onChange={item => {
                                        this.setState({ registrationUserId: item })
                                    }} >
                                    {this.state.allUsers.map(item => (
                                        <Option key={item._id} value={item._id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col span={8} >

                                <Select
                                    style={{ width: '200px' }}
                                    showSearch={true}
                                    mode="multiple"
                                    placeholder=" Please Choose Application Desk User"
                                    value={
                                        this.state.admissionUserId ? this.state.admissionUserId : []
                                    }
                                    onChange={item => {
                                        this.setState({ admissionUserId: item })
                                    }}>
                                    {
                                        this.state.admissionUsers.map(item => (
                                            <Option key={item._id} value={item._id}>
                                                {item.name}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </Col>
                            <Col span={4} >
                                <Button
                                    type="primary"
                                    size={'small'}
                                    style={{
                                        height: '32px',
                                        marginLeft: '15px',
                                        backgroundColor: 'green',
                                        border: '1px solid'
                                    }}
                                    onClick={() => {
                                        let { info } = this.state;


                                        if (this.state.course && this.state.course.length == 0) {
                                            return notification.error({
                                                message: 'Please choose atleast 1 COURSE to move the student to registration Desk.'
                                            })
                                        }
                                        if (this.state && this.state.info && this.state.i)
                                            if (this.state.registrationUserId.length == 0) {
                                                return notification.error({
                                                    message: 'Please select REGISTRAR to move the student to registration Desk.'
                                                })
                                            }
                                        const { dispatch } = this.props

                                        if (
                                            info &&
                                            info.profile &&
                                            (
                                                !info.profile.newQualification ||
                                                !info.profile.newQualification.length ||
                                                !(
                                                    info.haveEnglishTestScore === 'Yes' ||
                                                    info.haveEnglishTestScore === 'true' ||
                                                    info.haveEnglishTestScore === true
                                                )
                                            )
                                        ) {
                                            return Modal.confirm({
                                                title: 'Missing Qualification or Test Score',
                                                content: 'This student does not have a qualification or English Test score. Do you want to proceed?',
                                                okText: 'Yes, Move',
                                                cancelText: 'Cancel',
                                                onOk: () => {
                                                    dispatch(showLoader())
                                                    Request.movedToRegistrationDesk({
                                                        _id: this.state.inquiryId,
                                                        registrationUserId: this.state.registrationUserId,
                                                        admissionUserId: this.state.admissionUserId,

                                                    }).then(({ data, error, message }) => {
                                                        dispatch(hideLoader())
                                                        if (!error) {
                                                            notification.success({
                                                                message: message
                                                            })
                                                            this.setState({ moveNext: false })
                                                            this.setFormValues(this.state.inquiryId)
                                                            dispatch(getUrlPushWrapper('desk.counselling'))

                                                        } else {
                                                            notification.error({
                                                                message: message
                                                            })
                                                        }
                                                    })
                                                }
                                            });
                                        }
                                        dispatch(showLoader())
                                        Request.movedToRegistrationDesk({
                                            _id: this.state.inquiryId,
                                            registrationUserId: this.state.registrationUserId,
                                            admissionUserId: this.state.admissionUserId,
                                        }).then(({ data, error, message }) => {
                                            dispatch(hideLoader())
                                            if (!error) {
                                                notification.success({
                                                    message: message
                                                })
                                                this.setState({ moveNext: false })
                                                this.setFormValues(this.state.inquiryId)
                                                dispatch(getUrlPushWrapper('desk.counselling'))

                                            } else {
                                                notification.error({
                                                    message: message
                                                })
                                            }
                                        })
                                    }}
                                    loading={this.props.loading}>
                                    Process To Registration Desk
                                    <Icon type="right" />
                                </Button>
                            </Col>
                        </Card>
                    ) : null}
                </Form>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCounselling)
